export default "__VITE_ASSET__B07rAC_C__ 224w, __VITE_ASSET__FpQE6H5w__ 448w";